import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useOneStopService, { FILTER_TABS } from './useOneStopService';
import { RequestType } from './oneStopTypes';
import { useOneStopRequestsUrl } from './route/requests';
import { useOneStopHistoryUrl } from './route/history';
import OneStopModalLayout, { ModalData } from './OneStopModalLayout';

type OneStopModalProps = {
  data: Nullable<ModalData>;
  isError?: boolean;
  isOneStop?: boolean;
  handleMessageModalClose?: () => void;
};

const OneStopModal = ({ data, isError = false, isOneStop = true, handleMessageModalClose }: OneStopModalProps) => {
  const [modalData, setModalData] = useState<Nullable<ModalData>>(data);
  const navigate = useNavigate();
  const { getListUrl } = useOneStopRequestsUrl();
  const { getListUrl: getHistoryListUrl } = useOneStopHistoryUrl();
  const { invalidateCache } = useOneStopService();

  useEffect(() => {
    setModalData(data);
  }, [data]);

  const modalConfirmHandler = () => {
    const { requestId = null, requestType = null } = modalData || {};

    setModalData(null);

    if (handleMessageModalClose && !isError) {
      handleMessageModalClose();
    }

    if (isOneStop && !isError) {
      invalidateCache();

      let path;

      const isRequestInHistory = requestType == null || requestType === RequestType.TYPE_TASK_TRACKER_ISSUE;
      // process requests are not in the history
      if (isRequestInHistory) {
        path = `${getHistoryListUrl()}`;

        if (requestId) {
          path += `/${requestId}`;
        }
      } else {
        path = `${getListUrl()}?filter={"section":{"eq":"${FILTER_TABS.RECENT}"}}`;
      }

      navigate(path);
    }
  };

  return <OneStopModalLayout modalData={modalData} modalConfirmHandler={modalConfirmHandler} />;
};

export default OneStopModal;
